import { Box, lighten, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'left',
    marginBottom: '50px',
  },
  tableTitle: {
    marginTop: '20px',
    marginBottom: '30px',
    fontSize: '26px',
  },
  tableSubtitle: {
    marginTop: '20px',
    marginBottom: '20px',
    fontSize: '18px',
  },
  headerCell: {
    backgroundColor: lighten(theme.palette.primary.dark, 0.85),
    fontWeight: 'bold',
  },
}));

const DivergencyTable = (props) => {
  const classes = useStyles();

  const columns = [props.data.idField];
  const rows = [];
  let array = [];

  props.data.checkFields.forEach((fields) => {
    columns.push(fields.field);
    columns.push(fields.checkField);
  });

  props.data.divergentRows.forEach((row) => {
    array = [];

    if (row[props.data.idField]) {
      array.push(row[props.data.idField]);
    }

    props.data.checkFields.forEach((fields) => {
      if (row[fields.field]) {
        array.push(row[fields.field]);
      } else {
        array.push('');
      }

      if (row[fields.checkField]) {
        array.push(row[fields.checkField]);
      } else {
        array.push('');
      }
    });

    rows.push(array);
  });

  return (
    <Box className={classes.container}>
      <Box>
        {props.title ? <Typography className={classes.tableTitle}>{props.title}</Typography> : null}
        <Table>
          <TableHead>
            {columns.length > 1
              ? columns.map((column, index) => {
                  return (
                    <TableCell key={`${index}${column}`} className={classes.headerCell}>
                      {column}
                    </TableCell>
                  );
                })
              : null}
          </TableHead>
          <TableBody>
            {rows.length
              ? rows.map((row) => {
                  return (
                    <TableRow>
                      {row.map((r, i) => {
                        return <TableCell key={`${i + r}${r}`}>{r}</TableCell>;
                      })}
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default DivergencyTable;
